import {
  GET_CORPORATE_DATA,
  GET_CORPORATE_DATA_SUCCESS,
  GET_CORPORATE_DATA_FAILURE,
} from "../../Action/actionTypes";

const INIT_STATE = {
  loading: false,
  corporateData: [],
};

const getCorporateDataReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_CORPORATE_DATA:
      return { ...state, loading: true };
    case GET_CORPORATE_DATA_SUCCESS:
      return {
        ...state,
        corporateData: action?.payload,
        loading: false,
      };
    case GET_CORPORATE_DATA_FAILURE:
      return { ...state, loading: false };
    default:
      return state;
  }
};

export default getCorporateDataReducer;